
/**
 * 转换接口返回的数据为GameConfig的propertyConfig
 * @param {Array} data - 接口返回的数据数组
 * @returns {Array} - 转换后的 propertyConfig 数组
 */
export function convert2GameConfig(data, filterOriginDataGeneral = []) {
    if (!data || !Array.isArray(data)) {
        return []
    }

    const mappings = filterOriginDataGeneral.reduce((acc, cur) => {
        acc[cur.mappingField] = cur
        return acc
    }, {})

    const result = [], filterOriginData = []

    data.forEach(group => {
        if (!group.items || !Array.isArray(group.items)) {
            return
        }

        // 筛选条件1
        if (group.code === 'SEARCH_1') {
            group.items.forEach((item) => {
                const propertyConfig = {
                    propertyName: item.fieldName,
                    mappingField: item.mappingField,
                    fieldType: item.fieldType,
                }
                result.push({
                    ...propertyConfig,
                    mappingField: item.mappingField || 'single1',
                })
            })
        }
        // 排序方式
        if (group.code === 'SORT') {
            group.items.forEach((item) => {
                const propertyConfig = {
                    propertyName: item.fieldName,
                    mappingField: item.mappingField,
                    fieldType: item.fieldType,
                }
                result.push({
                    ...propertyConfig,
                    fieldType: 'SECTION'
                })
            })
        }
        if (group.code === 'SEARCH_2') {
            group.items.forEach((item) => {
                if (!mappings[item.mappingField]) {
                    filterOriginData.push({
                        ...item,
                        id: item.mappingField,
                        name: item.fieldName
                    })
                }
            })
        }
    })
    return { itemsGameConfig: result, filterOriginData }
}

/**
 * 获取商品目录ID
 * @param {Object} params - 请求参数对象
 * @param {boolean} isGeneralGoods - 是否为通用商品
 * @param {string} defaultGoodsCatalogueId - 默认商品目录ID
 * @returns {string} - 商品目录ID
 */
export function getCatalogueId(params, isGeneralGoods, defaultGoodsCatalogueId) {
    if (isGeneralGoods && params.catalogueId) {
        return params.catalogueId
    }
    return defaultGoodsCatalogueId
}

// 格式化销量数字
export function formatNums(num) {
	if (!num || num <= 0) {
		return 0
	}

	// 0 < 销量 < 100，显示真实值
	if (num < 100) {
		return num
	}
	// 100 <= 销量 < 1000，显示百位（向下取整）+ "+"
	else if (num < 1000) {
		return `${Math.floor(num / 100) * 100}+`
	}
	// 1000 <= 销量 < 10000，显示千位（向下取整）+ "k+"
	else if (num < 10000) {
		return `${Math.floor(num / 1000)}k+`
	}
	// 销量 >= 10000，显示万位（向下取整）+ "w+"
	else {
		return `${Math.floor(num / 10000)}w+`
	}
}

/**
 * 获取请求参数，1、过滤空值 2、通用商品需要特殊处理 _section 和 _single 结尾的参数
 * @param filter 过滤器
 * @returns 请求参数
 */
export function formatParams(filter) {
	const result = {}
	const sectionParams = {}
	const singleParams = {}

	// 遍历过滤器对象的所有键值对
	for (const [key, value] of Object.entries(filter)) {
		// 跳过空字符串
		if (value === '')
			continue

		// 通用商品需要特殊处理 _section 和 _single 结尾的参数
		// 变成 {section: {min: '100', max: '200'}}  格式的参数
        if (key.endsWith('_SECTION')) {
            const fieldNameWithPrefix = key.substring(0, key.indexOf('_SECTION'))
            let minMaxKey = ''
            let fieldName = ''

            // 提取 min_/max_ 前缀和字段名
            if (fieldNameWithPrefix.startsWith('min_')) {
                minMaxKey = 'min'
                fieldName = fieldNameWithPrefix.substring(4) // 去掉 'min_'
            }
            else if (fieldNameWithPrefix.startsWith('max_')) {
                minMaxKey = 'max'
                fieldName = fieldNameWithPrefix.substring(4) // 去掉 'max_'
            }

            if (minMaxKey && fieldName) {
                if (!sectionParams.section) {
                    sectionParams.section = {}
                }
                if (!sectionParams.section[fieldName]) {
                    sectionParams.section[fieldName] = {}
                }
                sectionParams.section[fieldName][minMaxKey] = value
                continue
            }
        }
        if (key.endsWith('_SINGLE')) {
            singleParams[key.replace('_SINGLE', '')] = value
            continue
        }

		// 其他参数正常处理
		result[key] = value
	}

	// 添加分组参数
	if (Object.keys(sectionParams).length > 0)
		result.section = sectionParams.section
	if (Object.keys(singleParams).length > 0)
		result.single = singleParams

	return result
}
